
function translateReviewWidget(element1) {

    // Dictionary for Conversion between Trad and Simp Chinese 
    const translateDict = {
      "顾客": "顧客",
      "写": "寫",
      "评论": "評論",      
      "满分": "滿分",
      "根据": "根據",
      "评级": "評級",
      "首先是图片": "有圖片的評論優先",
      "只有图片": "只列出有圖片的評論",
      "视频第一": "有影片的評論優先",
      "让客户为我们说话": "五星級服務",
      "来": "來",
      "条": "條"
    };

    // Replace the Words
    for (const [key, value] of Object.entries(translateDict)) {
      if (element1.includes(key)) {
        element1 = element1.replace(key, value);
      }
    }
    return element1;
}

function replaceText() {
  
  if (window.location.href.includes("zh-hant")){
    // for Products Review
    if (window.location.href.includes("product")) {
      for (const element of [".jdgm-rev-widg__title", ".jdgm-rev-widg__summary-average", ".jdgm-rev-widg__summary-text", ".jdgm-write-rev-link", ".jdgm-rev-widg__sort-wrapper .jdgm-sort-dropdown option:first-child", ".jdgm-rev-widg__sort-wrapper .jdgm-sort-dropdown option:nth-child(2)", ".jdgm-rev-widg__sort-wrapper .jdgm-sort-dropdown option:nth-child(3)", ".jdgm-rev-widg__sort-wrapper .jdgm-sort-dropdown option:nth-child(4)", ".jdgm-rev-widg__sort-wrapper .jdgm-sort-dropdown option:nth-child(5)", ".jdgm-rev-widg__sort-wrapper .jdgm-sort-dropdown option:nth-child(6)", ".jdgm-rev-widg__sort-wrapper .jdgm-sort-dropdown option:nth-child(7)"]) {
        document.querySelector(element).textContent = translateReviewWidget(document.querySelector(element).textContent);
      }
    // for Homepage Review
    } else {
      for (const element of [".jdgm-carousel-title", ".jdgm-carousel-number-of-reviews"]) {
        document.querySelector(element).textContent = translateReviewWidget(document.querySelector(element).textContent);
      }
    }
  }
  
}

// Delay the Function to Ensure the Script is Executed after all Elements are Loaded
setTimeout(replaceText, 3000);